module.exports = __webpack_public_path__ + "static/media/CheckCircle.b7f7cf1f.svg";